import { useEffect, useState } from 'react'
import ContractService from '@/utils/services/contract'
import {
  AddressDetailsReadonly,
  AddressValues,
  AdressFromAPIToForm,
  UseAutofill,
  UseAutofillInputReturn,
} from '@/types/v2/address'
import { capitalize, getAddressDetailsWithPreviousValues } from '@/utils/helpers/address'

export const useAutofillAddress = ({ previousValues, mustReset }: UseAutofill): UseAutofillInputReturn => { 
  const [states, setStates] = useState([])
  const [isAdding, setIsAdding] = useState(false)
  const [addressDetails, setAddressDetails] = useState<AddressDetailsReadonly>({
    streetAddress: '',
    extraInfo: '', 
    city: '',
    county:'',
    state: null,
    zipCode: '',
  })
 
  const handleGetStates = async () => {
    const { data } = await ContractService.getStatesdata()
    if (data) setStates(data)
  }

  useEffect(() => {
    handleGetStates()
  }, [])

  useEffect(() => {
    if (mustReset) {
      setAddressDetails({
        streetAddress: '',
        extraInfo: '',
        city: '',
        county:'',
        state: null,
        zipCode: '',
      })
    }
  }, [mustReset])

  useEffect(() => {
    if (states.length > 0 && previousValues) { 
      setAddressDetails(getAddressDetailsWithPreviousValues(previousValues, states))
    }
  }, [states.length,previousValues])

  return {
    states,
    isAdding,
    addressDetails, 
    toggleIsAdding: () => setIsAdding(!isAdding),
    setIsAdding
  }
}
